import { applicationSettingsClientApi } from "./applicationSettingsClientApi";
import { incidentClientApi } from "./incidentClientApi";
import { portalClientApi } from "./portalClientApi";


export const clientApi = {
    applicationSettings: applicationSettingsClientApi,
    portal: portalClientApi,
    incident: incidentClientApi
};